import type { OfficialResource } from "@shikaku/shared";

interface OfficialViewProps {
  resources: OfficialResource[];
  primaryColor: string;
}

export function OfficialView({ resources, primaryColor }: OfficialViewProps) {
  return (
    <div style={{ flex: 1, overflowY: "auto" }}>
      <div style={{ padding: "16px 20px", fontSize: 13, fontWeight: 700, color: "#888" }}>
        公式過去問・受験情報
      </div>

      <div style={{ background: "#fff" }}>
        {resources.map((res, i) => (
          <div key={res.id}>
            <a
              href={res.url}
              target="_blank"
              rel="noopener noreferrer"
              className="list-row"
              style={{ textDecoration: "none" }}
            >
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 600, color: "#333" }}>
                  {res.title}
                </div>
                <div style={{ fontSize: 13, color: "#999", marginTop: 2 }}>{res.subtitle}</div>
              </div>
              <svg width="16" height="16" fill="none" stroke={primaryColor} strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
            {i < resources.length - 1 && <div style={{ margin: "0 20px", borderTop: "1px solid #f0f0f0" }} />}
          </div>
        ))}
      </div>
    </div>
  );
}
